import React from "react";
import PropTypes from "prop-types";
import QrReader from 'react-qr-reader';
import css from "./css";
import { Spinner } from "../../native-ui";
export class QrScanner extends React.Component {
    static propTypes = {
        width: PropTypes.string,
        loading: PropTypes.bool,
        show: PropTypes.bool.isRequired,
        onScan: PropTypes.func.isRequired,
        onError: PropTypes.func,
        onLoad: PropTypes.func,
        facingMode: PropTypes.oneOf(["environment", "user"]),
    }

    static defaultProps = {
      width: "300px",
      facingMode: "user",
    }

    toggleShow = () => {
            this.props.onToggle?.(!this.props.show);
    };

    toggleType = () => {
      this.setState({
        type: Number(!this.state.type),
      });
    };
  
    handleScan = (data) => {
      if (data === null) { return; }
      this.props.onScan(data);
    };

    renderLoading() {
      return <div style={{ "--full-size": this.props.width, }}><Spinner containerClassName={css.qr_scanner_loader} /></div>
    }
  

    render() {
        if (!this.props.show) return null;

        if (this.props.loading) {
          return this.renderLoading();
        }

        return (
            <QrReader
              className={css.qr_scanner}
              delay={300}
              onScan={this.handleScan}
              onError={this.props.onError}
              onLoad={this.props.onLoad}
              facingMode={this.props.facingMode}
              style={{ width: this.props.width, maxWidth: "100%", marginTop: "1em", marginLeft: "auto", marginRight: "auto" }}
            />
        )
    }
}